import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import csc from "country-state-city";
import { toastr } from "react-redux-toastr";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Layout, Typography, Tabs, Row, Col, Input, Select, Button, Rate, Dropdown, Breadcrumb } from "antd";
import Icon from "../../components/customIcons/customIcons";
import { getDetailPageRoute } from "../../common/getRoutes";
import { DownOutlined, PlusOutlined, MinusOutlined } from "@ant-design/icons";
import {
  addToCartAction,
  checkFedexStatusAction,
  getItemDetailsAction,
  loadingAction,
  openLoginModel,
  toggleWishlistAction,
} from "../../store/actions/index";
import { langs } from "../../config/localization";
import moment from "moment";
import { convertHTMLToText, salaryNumberFormate, getAddress } from "../common";
import { STATUS_CODES } from "../../config/StatusCode";
import { MESSAGES } from "../../config/Message";
import { SocialShare } from "../common/social-share";
import { rating } from "../classified-templates/CommanMethod";
import { getCategoryListingRoutes } from "../../common/getRoutes";
import ProductReviews from "./ProductReviews";
import { capitalizeFirstLetter } from "../common";
import SellerInformation from "./SellerInformation";
import PostageAndPayments from "./PostageAndPayments";
import ProductDescription from "./ProductDescription";
import Slider from "react-slick";
import DefaultProductImage from "../../assets/images/defaultProductImage.png";
import { ReactComponent as SliderCloseIcon } from "../../assets/images/new-images/close-icon.svg";
import { ReactComponent as SliderLeftIcon } from "../../assets/images/new-images/arrow_left.svg";
import { ReactComponent as SliderRightIcon } from "../../assets/images/new-images/arrow_right.svg";
import ViewSizeGuide from "../../modals/ViewSizeGuide";
import { replaceImageURL } from "../../common/Navigation";

const { Title, Text } = Typography;
const { TabPane } = Tabs;
const { Option } = Select;

class ProductDetails extends React.Component {
  formRef = React.createRef();

  myDivToFocus = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      slug: '',
      product_id: '',
      classifiedDetail: [],
      allData: "",
      visible: false,
      bookProduct: false,
      reviewModel: false,
      filteredData: [],
      isFilter: false,
      label: "All Feedback",
      reviewTab: false,
      activeTab: "1",
      carouselNav1: null,
      carouselNav2: null,
      showNumber: false,
      is_favourite: false,
      colorArray: [],
      sizeArray: [],
      groupAtt: [],
      available_quantity: 0,
      selectedQuantity: 1,
      invAttData: "",
      children: [],
      leaveFeedback: false,
      seeMore: false,
      sizeGuideModel: false,
      reportAdModel: false,
      isPostageOpen: false,
      label_1: "",
      label_2: "",
      exclusion: "",
      posting_to: "",
      activePanel: "1",
      number: "1",
      postage_delivery: [],
      postingCountryList: [],
      allCountries: csc.getAllCountries(),
      postage_section: "",
      geoLocation: "",
      product_image: "",
      isOpenSliderModal: false,
    };
  }

  /**
   * @method componentWillReceiveProps
   * @description receive props from components
   */
  componentWillReceiveProps(nextprops, prevProps) {
    let slug = this.props.match.params.slug;
    let nextslug = nextprops.match.params.slug;
    if (slug !== nextslug) {
      this.getDetails(nextslug);
    }
  }

  /**
   * @method componentWillMount
   * @description get selected categorie details
   */
  componentWillMount() {
    this.props.loadingAction(true);
    let slug = this.props.match.params.slug;
    this.getDetails(slug);
    this.getCurrentLocation();
  }

  /**
   * @method componentDidMount
   * @description called after render the component
   */
  componentDidMount() {
    this.setState({
      carouselNav1: this.slider1,
      carouselNav2: this.slider2,
    });
  }

  /**
   * @method getDetails
   * @description get classified details
   */
  getDetails = (slug, filterKey) => {

    let product_id = slug.split('-').pop();
    let params = {
      page: langs.modules.retail,
      product_id: product_id,
      filter: filterKey ? filterKey : "top_rated",
      feedback_sort: filterKey ? filterKey : "recent",
    };
    this.props.getItemDetailsAction(params, (res) => {
      this.props.loadingAction(false);
      // let details = this.props.itemDetails;
      let details = res.data;
      let is_favourite = details && details.data && details.data.is_favourite === 1 ? true : false;
      let similarAd = details.similaradd;
      let invAttData = details && details.inv_attribute_group_new,
        defaultColor = "",
        product_image = "",
        inv_title1 = "",
        inv_title2 = "",
        child = "";
      let groupAtt = details && details.inv_attribute_group_new && details.inv_attribute_group_new.inv_attributes && Array.isArray(details.inv_attribute_group_new.inv_attributes) && details.inv_attribute_group_new.inv_attributes.length ? details.inv_attribute_group_new.inv_attributes : [];
      if (groupAtt && Array.isArray(groupAtt) && groupAtt.length) {
        defaultColor = groupAtt[0];
        inv_title1 = groupAtt[0].display_name;
        product_image = groupAtt[0].images;
        child = groupAtt[0].children && Array.isArray(groupAtt[0].children) && groupAtt[0].children.length ? groupAtt[0].children : "";
        inv_title2 = child && child[0].display_name;
      }
      let business_details = details && details.data ? details.data.classified_business : "";
      let postages = business_details && business_details.postages && Array.isArray(business_details.postages) && business_details.postages.length ? business_details.postages : [];
      // let temp = [],
      //   temp2 = [],
      //   result = [];
      // if (exclusion) {
      //   result = this.state.allCountries.filter((o) => !exclusion.some((v) => v.name === o.name));
      //   exclusion &&
      //     exclusion.map((el) => {
      //       temp.push(el.country);
      //     });
      // }
      // result &&
      //   result.length &&
      //   result.map((el) => {
      //     temp2.push(el.name);
      //   });
      let postingCountryList = this.state.allCountries.filter((o) => postages.some((v) => v.country === o.name));

      let postingTo = postages && postages.length ? postages.map(post => post.country) : []
      let excluding = postages && postages.length ? postages.map(post => post.excludes_states) : []

      this.setState(
        {
          product_id: product_id,
          classifiedDetail: details && details.data,
          parentCatId: details && details.data && details.data.parent_categoryid,
          allData: details,
          is_favourite: is_favourite,
          groupAtt: groupAtt,
          invAttData: invAttData,
          available_quantity: details && details.data.quantity,
          similarAd: similarAd,
          children: child,
          selectedColor: defaultColor && defaultColor.id,
          label_1: defaultColor && defaultColor.display_name,
          label_2: child && Array.isArray(child) && child.length ? child[0].display_name : "",
          selectedColorName: defaultColor && defaultColor.inv_attribute_value,
          exclusion: excluding && excluding.length ? excluding.join() : "",
          posting_to: postingTo && postingTo.length ? postingTo.join() : "",
          postingCountryList: postingCountryList ? postingCountryList : [],
          inv_title1: inv_title1 ? inv_title1 : "",
          inv_title2: inv_title2 ? inv_title2 : "",
          product_image: details && details.data.is_inventory_added === 1 ? product_image : details && details.data.classified_image,
        },
        () => {
          // this.getFedexResponse("");
        }
      );
    }, (rej) => {
      this.props.loadingAction(false);
    });

  };

  getCurrentLocation = () => {
    const { lat, long } = this.props;
    getAddress(lat, long, (res) => {
      let state = '';
      let city = '';
      let pincode = '';
      let country = ''
      let area = ''
      let locality = ''
      let state_code = ''
      let country_code = ''

      res.address_components && res.address_components.forEach((el) => {
        switch (el.types[0]) {
          case 'route':
            area += el.long_name
            return
          case 'locality':
            area += " " + el.long_name
            locality = el.long_name
            return
          case 'administrative_area_level_1':
            state = el.long_name
            state_code = el.short_name;
            return
          case 'administrative_area_level_2':
            city = el.long_name
            return
          case 'postal_code':
            pincode = el.long_name
            return
          case 'country':
            country = el.long_name
            country_code = el.short_name;
            return

        }
      })
      if (!city) { city = locality; }
      let geoLocation = {
        location: res.formatted_address,
        lat: lat,
        lng: long,
        country: country,
        country_code: country_code.substring(0, 2),
        state: state,
        state_code: state_code.substring(0, 2),
        city: city,
        pincode: pincode,
      };
      this.setState({ geoLocation: geoLocation });
    });
  };

  /**
   * @method getFedexAPI
   * @description fetch shipping details
   */
  getFedexAPI = (reqData) => {
    const formData = new FormData();
    Object.keys(reqData).forEach((key) => {
      if (typeof reqData[key] == "object") {
        formData.append(key, JSON.stringify(reqData[key]));
      } else {
        formData.append(key, reqData[key]);
      }
    });
    this.props.checkFedexStatusAction(formData, (res) => {
      if (res.status === STATUS_CODES.OK) {
        let temp = Array.isArray(res.data.data) && res.data.data.length ? res.data.data[0] : "";
        this.setState({
          postage_delivery: res.data ? res.data.data : [],
          postage_section: temp,
        });
      }
    });
  };

  /**
   * @method getFedexResponsebyCountryCode
   * @description get selected country details
   */
  getFedexResponsebyCountryCode = (selected_country_code) => {
    const { classifiedDetail } = this.state;
    let shipper = classifiedDetail && classifiedDetail.classified_users;
    let data = classifiedDetail ? classifiedDetail : "";
    const reqData = {
      StreetLines_Shipper: shipper ? shipper.business_location : "",
      City_Shipper: shipper ? shipper.city : "",
      StateOrProvinceCode_Shipper: shipper && shipper.state_code ? shipper.state_code.substring(0, 2) : "",
      PostalCode_Shipper: shipper ? shipper.business_pincode : "",
      CountryCode_Shipper: shipper && shipper.country_code ? shipper.country_code.substring(0, 2) : "",
      CountryCode_Recipient: selected_country_code ? selected_country_code.substring(0, 2) : "",
      packages: [
        {
          Weight: data && data.weight,
          Length: data && data.length,
          Width: data && data.width,
          Height: data && data.height,
          GroupPackageCount: "1",
        },
      ],
    };
    this.getFedexAPI(reqData);
  };

  /**
   * @method getFedexResponse
   * @description get fedex shipping details
   */
  getFedexResponse = (selected_country_code) => {
    const { geoLocation, classifiedDetail } = this.state;
    let shipper = classifiedDetail && classifiedDetail.classified_users;
    let data = classifiedDetail ? classifiedDetail : "";
    const reqData = {
      StreetLines_Shipper: shipper ? shipper.business_location : "",
      City_Shipper: shipper ? shipper.city : "",
      StateOrProvinceCode_Shipper: shipper && shipper.state_code ? shipper.state_code.substring(0, 2) : "",
      PostalCode_Shipper: shipper ? shipper.business_pincode : "",
      CountryCode_Shipper: shipper && shipper.country_code ? shipper.country_code.substring(0, 2) : "",
      StreetLines_Recipient: geoLocation ? geoLocation.location : "13450 Farmcrest Ct",
      City_Recipient: geoLocation ? geoLocation.city : "Herndon",
      StateOrProvinceCode_Recipient: geoLocation ? geoLocation.state_code : "VA",
      PostalCode_Recipient: geoLocation ? geoLocation.pincode : "20171",
      CountryCode_Recipient: geoLocation ? geoLocation.country_code : "US",
      packages: [
        {
          Weight: data && data.weight,
          Length: data && data.length,
          Width: data && data.width,
          Height: data && data.height,
          GroupPackageCount: "1",
        },
      ],
    };
    this.getFedexAPI(reqData);
    // }
  };

  /**
   * @method handleAdTocart
   * @description handle add to cart
   */
  handleAdTocart = (requestData) => {
    this.props.addToCartAction(requestData, (res) => {
      if (res.data.success) {
        toastr.success(langs.success, MESSAGES.AD_TO_CART);
        this.setState({ visible: true });
      } else {
        res.data?.message && toastr.error(langs.error, res.data.message);
      }
    });
  };

  /**
   * @method addToCart
   * @description add to cart
   */
  addToCart = () => {
    const { isLoggedIn } = this.props;
    const { selectedQuantity, selectedColor } = this.state;
    let slug = this.props.match.params.slug;
    let classified_id = slug.split('-').pop();
    // let classified_id = this.props.match.params.classified_id;
    if (isLoggedIn) {
      let requestData = {
        classifiedInvAttr_group_id: selectedColor ? selectedColor : 0,
        qty: selectedQuantity,
        classified_id: classified_id
      };
      if (selectedQuantity) {
        this.handleAdTocart(requestData);
      } else {
        toastr.warning("Please enter product quantity");
      }
    } else {
      this.props.openLoginModel();
    }
  };

  /**
   * @method bookProductModal
   * @description handle make an offer model
   */
  bookProductModal = () => {
    const { selectedQuantity, classifiedDetail } = this.state;
    const { isLoggedIn } = this.props;
    if (classifiedDetail && classifiedDetail.price === 0) {
      toastr.warning(langs.warning, MESSAGES.NOT_ABLE_APPLY_OFFER);
      return true;
    } else {
      if (isLoggedIn) {
        if (selectedQuantity) {
          this.setState({
            bookProduct: true,
          });
        } else {
          toastr.warning("Please enter product quantity");
        }
      } else {
        this.props.openLoginModel();
      }
    }
  };

  /**
   * @method contactModal
   * @description contact model
   */
  leaveReview = () => {
    const { classifiedDetail, loggedInUser, isLoggedIn } = this.props;
    let feedback = classifiedDetail && classifiedDetail.feedback && Array.isArray(classifiedDetail.feedback) && classifiedDetail.feedback.length ? classifiedDetail.feedback : [];
    if (isLoggedIn) {
      if (feedback && feedback.length) {
        feedback.some((el) => {
          if (el.user_id === loggedInUser.id) {
            toastr.warning("warning", "You have already added your review.");
            this.setState({ isUserExits: true, leaveFeedback: false });
          } else {
            this.setState({ isUserExits: false, leaveFeedback: true });
          }
        });
      } else if (feedback.length === 0) {
        this.setState({ isUserExits: false, leaveFeedback: true });
      }
    } else {
      this.props.openLoginModel();
    }
  };

  /**
   * @method handleCancel
   * @description handle cancel
   */
  handleCancel = (e) => {
    this.setState({
      visible: false,
      bookProduct: false,
      reviewModel: false,
      leaveFeedback: false,
    });
  };

  /**
   * @method renderSpecification
   * @description render specification list
   */
  renderSpecification = (data) => {
    let temp = data && Array.isArray(data) && data.length ? data.filter((el) => el.key !== "Features" && el.key !== "Price") : [];
    let sorted_list =
      temp &&
      temp.sort((a, b) => {
        if (a.position < b.position) return -1;
        if (a.position > b.position) return 1;
        return 0;
      });
    return (
      sorted_list &&
      Array.isArray(sorted_list) &&
      sorted_list.map((el, i) => {
        let value = el.key === "Price" ? `AU$${salaryNumberFormate(el.value)}` : el.value;
        return (
          <Fragment key={i}>
            <li>
              <strong>{el.key}:</strong>
              <span>{value}</span>
            </li>
          </Fragment>
        );
      })
    );
  };

  /**
   * @method toggleWishlist
   * @description handle favorite unfavorite
   */
  toggleWishlist = (classified_id) => {
    const { isLoggedIn } = this.props;
    const { is_favourite } = this.state;
    if (isLoggedIn) {
      const requestData = { item_id: classified_id };
      this.props.loadingAction(true);
      this.props.toggleWishlistAction(requestData, (res) => {
        this.props.loadingAction(false);
        if (res.success) {
          let slug = this.props.match.params.slug;
          this.getDetails(slug);
        } else {
          res?.message && toastr.error(langs.error, res.message);
        }
      });
    } else {
      this.props.openLoginModel();
    }
  };

  activeTab = (tab, panel) => {
    this.setState({ activeTab: tab, activePanel: panel });
    if (this.myDivToFocus.current) {
      window.scrollTo(0, this.myDivToFocus.current.offsetTop);
    }
  };

  /**
   * @method onTabChange
   * @description manage tab change
   */
  onTabChange = (key, type) => {
    this.setState({ activeTab: key, reviewTab: false });
  };

  /**
   * @method renderSize
   * @description render size
   */
  renderSize = (size) => {
    if (size && size.length) {
      return size.map((el, i) => {
        return (
          <Option key={i} value={el.inv_attribute_value}>
            {el.inv_attribute_value}
          </Option>
        );
      });
    }
  };

  /**
   * @method handleQuantityChange
   * @description handle quantity change
   */
  handleQuantityChange = (e) => {
    const { available_quantity } = this.state;
    if (e > available_quantity) {
      toastr.warning("Selected quantity are not available for this product");
    } else {
      this.setState({ selectedQuantity: e });
    }
  };

  /**
   * @method onItemSelection
   * @description handle product item selection
   */
  onItemSelection = (data) => {
    let obj = data && JSON.parse(data);
    let children = [];
    let quantity = 0;
    let temp = obj && Array.isArray(obj.children) && obj.children.length ? obj.children : [];

    if (temp && temp.length) {
      temp &&
        temp.length &&
        temp.map((el, i) => {
          children.push({ id: i, inv_attribute_value: el.inv_attribute_value });
          quantity = quantity + Number(el.quantity);
        });
    }
    this.setState({
      selectedColor: obj.id,
      children: children,
      selectedColorName: obj.inv_attribute_value,
      product_image: obj.images,
      available_quantity: quantity ? quantity : obj.quantity ? obj.quantity : 0,
    });
  };

  renderColorOption = (groupAtt) => {
    return (
      groupAtt &&
      groupAtt.length &&
      groupAtt.map((el, i) => {
        return (
          <Option key={i} value={JSON.stringify(el)}>
            {el.inv_attribute_value}
          </Option>
        );
      })
    );
  };

  handleNumberChange = (key) => {
    let { selectedQuantity, available_quantity } = this.state;
    switch (key) {
      case 'increment':
        if (selectedQuantity === available_quantity)
          toastr.warning("Selected quantity are not available for this product");
        else
          selectedQuantity++;
        break;
      case 'decrement':
        if (selectedQuantity === 0)
          toastr.warning("Please select quantity greater than 0");
        else
          selectedQuantity--;
        break;
      default:
        if (key > available_quantity)
          toastr.warning("Selected quantity are not available for this product");
        else if (key < 0)
          toastr.warning("Please select quantity greater than 0");
        else
          selectedQuantity = key;
    }
    this.setState({ selectedQuantity: selectedQuantity });
  };

  /**
   * @method renderInvAttSection
   * @description render inv att section
   */
  renderInvAttSection = () => {
    const { selectedQuantity, groupAtt, children, available_quantity, selectedColorName } = this.state;
    let quantity = [];
    for (let i = 1; i < available_quantity; i++) {
      quantity.push({ key: i, value: i });
    }

    if (groupAtt && groupAtt.length) {
      let title1 = groupAtt[0].display_name ? groupAtt[0].display_name : "Product Description";
      let child = groupAtt[0].children && Array.isArray(groupAtt[0].children) && groupAtt[0].children.length ? groupAtt[0].children[0] : "";
      let title2 = child ? child.display_name : "Select";
      return (
        <div className='variationOptions'>
          <Row gutter={[16, 30]}>
            <Col xs={{ span: 24 }} lg={{ span: 12 }}>
              <div className=''>
                <label for='select-colour'>Select {title1}</label>
                <Select value={selectedColorName} onChange={(e) => this.onItemSelection(e)}>
                  {this.renderColorOption(groupAtt)}
                </Select>
              </div>
            </Col>
            {children.length ?
              <Col xs={{ span: 16 }} lg={{ span: 12 }}>
                <div className=''>
                  <label for='select-size'>Select {title2}</label>
                  <Select defaultValue={"..."} onChange={(e) => this.setState({ selectedSize: e })}>
                    <Option hidden>...</Option>
                    {children && children.length && this.renderSize(children)}
                  </Select>
                </div>
              </Col> : ""}
            <Col xs={{ span: 8 }} lg={{ span: 8 }}>
              <label for='select-quantity'>Select Quantity</label>
              <div className='chooseQuantity'>
                <MinusOutlined onClick={() => this.handleNumberChange("decrement")} />
                <Input type='number' value={selectedQuantity} onChange={(e) => this.handleNumberChange(e.target.value)} />
                <PlusOutlined onClick={() => this.handleNumberChange("increment")} />
              </div>
            </Col>
          </Row>
        </div>
      );
    }
  };

  /**
   * @method renderPaymentMethods
   * @description render payment methods
   */
  renderPaymentMethods = (business_detail, is_visible) => {
    return (
      business_detail && (
        <div className='paymentSelector'>
          {/* {is_visible && <label>Payments:</label>} */}
          <div className='paymentIcons'>
            {business_detail.is_paypal_accepted ? <img src={require("../../assets/images/icons/paypal.svg")} alt='paypal' /> : null}
            {business_detail.is_stripe_accepted ? <img src={require("../../assets/images/stripe-transparent-icon.png")} alt='stripe' /> : null}
            {business_detail.is_mastercard ? <img src={require("../../assets/images/icons/mastero.svg")} alt='mastero' /> : null}
            {business_detail.is_visa ? <img src={require("../../assets/images/icons/visa.svg")} alt='visa' /> : null}
            {business_detail.is_gpay ? <img src={require("../../assets/images/icons/gpay.svg")} alt='gpay' /> : null}
            {business_detail.is_applepay ? <img src={require("../../assets/images/icons/apple-pay.svg")} alt='apple-pay' className='aferpay' /> : null}
            {!is_visible ? <span className='custom-br'></span> : null}
            {business_detail.is_afterpay ? <img src={require("../../assets/images/icons/after-pay.svg")} alt='apple-pay' className='apple-pay-img' /> : null}
            {is_visible ? (
              <span className='available'>
                maybe available{" "}
                <a href='Javasript:void(0)' onClick={() => this.activeTab("4", "3")}>
                  Learn More
                </a>
              </span>
            ) : null}
          </div>
          <hr style={{ margin: "20px 0 0" }} />
        </div>
      )
    );
  };

  mainImageGallery = (item, index, length, itemToShow) => {
    return (
      <>
        {item ? (
          <div className='mainImageBox'>
            <div className='imageSize'>
              <img
                key={index}
                src={replaceImageURL(item, 400, 560)}
                alt=''
                className='productImg'
                onClick={() => {
                  this.setState({
                    isOpenSliderModal: !this.state.isOpenSliderModal,
                  });
                }}
              />

              {(itemToShow === 4 && index === 3) || (itemToShow === 2 && index === 1)
                ? length && (length - itemToShow) > 0 ? (
                  <div
                    className='overlay'
                    onClick={() => {
                      this.setState({
                        isOpenSliderModal: !this.state.isOpenSliderModal,
                      });
                    }}
                  >{`${length - itemToShow} +`}</div>
                ) : null : null}
            </div>
          </div>
        ) : (
          <img src={DefaultProductImage} alt='' />
        )}
      </>
    );
  };

  /**
   * @method render
   * @description render component
   */
  render() {
    const { isLoggedIn } = this.props;
    if (this.state.allData) {
      let data = this.state.allData.data;
      const { inv_title1, sizeGuideModel, product_id, product_image, postage_section, postingCountryList, postage_delivery, available_quantity, groupAtt, posting_to, exclusion, selectedColorName, isPostageOpen, label, is_favourite, classifiedDetail, activeTab, allData, similarAd } = this.state;
      let { selectedQuantity } = this.state;
      let rate = classifiedDetail && classifiedDetail.classified_hm_reviews && rating(classifiedDetail.classified_hm_reviews);
      let parameter = this.props.match.params;
      let cat_id = parameter.categoryId;
      let slug = this.props.match.params.slug;
      let classified_id = slug.split('-').pop();
      // let classified_id = parameter.classified_id;
      let categoryName = classifiedDetail.category ? classifiedDetail.category.name : "";
      let subCategoryName = classifiedDetail.sub_category ? classifiedDetail.sub_category.name : "";
      let categoryPagePath = classifiedDetail.category ? getCategoryListingRoutes('retail', classifiedDetail.category.name, 1, classifiedDetail.category.id) : "";
      let subCategoryPagePath = classifiedDetail.sub_category ? getCategoryListingRoutes('retail', classifiedDetail.sub_category.name, 2, classifiedDetail.sub_category.id, classifiedDetail.category) : "";
      let childCategoryPagePath = classifiedDetail.child_category ? getCategoryListingRoutes('retail', classifiedDetail.child_category.name, 3, classifiedDetail.child_category.id) : "";
      const catName = classifiedDetail.category && classifiedDetail.category.name;
      let avl_qty = available_quantity ? available_quantity : 10;
      let quantity = [];
      for (let i = 1; i < avl_qty; i++) {
        quantity.push({ key: i, value: i });
      }
      const menu = <SocialShare {...this.props} />;

      let temp = postage_section && postage_section.RateTypes && Array.isArray(postage_section.RateTypes) && postage_section.RateTypes.length ? postage_section.RateTypes[0].split(":") : "";
      let poatage_price = temp && Array.isArray(temp) && temp.length > 1 ? temp[1] : "";
      let postage_details = classifiedDetail && classifiedDetail.classified_business?.address;
      let business_detail = classifiedDetail ? classifiedDetail.classified_business : "";
      let mid_level_cat = classifiedDetail && classifiedDetail.sub_category ? classifiedDetail.sub_category.name : "";
      let sizevisible = categoryName === "Women" || categoryName === "Men" || categoryName === "Children" || mid_level_cat === "Babywear" || mid_level_cat === "Sleep";

      let slickSettingsSimilarProduct = {
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        nextArrow: <SliderRightIcon />,
        prevArrow: <SliderLeftIcon />,
        responsive: [
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 380,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      }

      if (similarAd && similarAd.length > 5) {
        slickSettingsSimilarProduct.infinite = true
      }


      const slickSettingsMobileSlider = {
        dots: true,
        dotsClass: "slick-dots slick-thumb",
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        customPaging: (i) => <img src={product_image && product_image[i].full_name && product_image[i].full_name} alt='' />,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              customPaging: (i) => <span className='dot'></span>,
            },
          },
        ],
      };

      const { Content } = Layout;
      let size_guide_image = this.state.allData?.size_guide_image;
      sizevisible = true;
      return (
        <>
          <Layout className='retailProductDetailMain layoutWithoutBanner'>
            <div className='container productDetailContainer'>
              <div className='productTopSection'>
                <div className='mainImageGallery'>
                  <div className='mainImageBoxWrap'>
                    {product_image && product_image.length >= 4 ? (
                      <>
                        {product_image.slice(0, 4).map((item, index) => {
                          return this.mainImageGallery(item.full_name && item.full_name, index, product_image.length, 4);
                        })}
                      </>
                    ) : (
                      <>
                        {product_image && product_image.length > 0 && product_image.slice(0, 2).map((item, index) => {
                          return this.mainImageGallery(item.full_name && item.full_name, index, product_image.length, 2);
                        })}
                      </>
                    )}
                  </div>
                </div>
                <div className={this.state.isOpenSliderModal === true ? "mainImageSlider open" : "mainImageSlider"}>
                  <div
                    className='closeSlider'
                    onClick={() => {
                      this.setState({ isOpenSliderModal: false });
                    }}
                  >
                    <SliderCloseIcon />
                  </div>
                  <Slider {...slickSettingsMobileSlider}>
                    {product_image && product_image.map((slide, i) => (
                      <div
                        key={i}
                        className='d-block parent-d-block'
                        onClick={() => {
                          //this.viewGalleryModal(slides);
                        }}
                      >
                        <img src={slide.full_name && slide.full_name} alt='' />
                      </div>
                    ))}
                  </Slider>
                </div>

                <div className='productSummary retail'>
                  <div className='productSummaryData abv'>
                    <Breadcrumb separator='|' className='ant-breadcrumb-pad categoryLandingBreadcrumb retail'>
                      <Breadcrumb.Item>
                        <Link to='/'>Home</Link>
                      </Breadcrumb.Item>
                      <Breadcrumb.Item>Retail</Breadcrumb.Item>
                      <Breadcrumb.Item>
                        <Link to={categoryPagePath}>{data && data.category && data.category.name}</Link>
                      </Breadcrumb.Item>
                      <Breadcrumb.Item>
                        <Link to={subCategoryPagePath}>{data && data.sub_category && data.sub_category.name}</Link>
                      </Breadcrumb.Item>
                      {/* {data.child_category &&
                        <Breadcrumb.Item>
                          <Link to={childCategoryPagePath}>{data && data.child_category && data.child_category.name}</Link>
                        </Breadcrumb.Item>} */}
                    </Breadcrumb>
                    <Row gutter={[12, 12]}>
                      <Col flex='calc(100% - 45px)'>
                        {classifiedDetail && classifiedDetail.title && (
                          <Title level={3} className='productName'>
                            {capitalizeFirstLetter(classifiedDetail.title)}
                          </Title>
                        )}
                      </Col>
                      <Col flex='45px'>
                        <Dropdown overlay={menu} trigger={["click"]} overlayClassName='contact-social-detail share-ad' placement='bottomCenter' arrow>
                          <div className='shareLink' onClick={(e) => e.preventDefault()}>
                            <Icon icon='share' size='27' />
                          </div>
                        </Dropdown>
                      </Col>
                    </Row>
                    <Row gutter={[16, 16]}>
                      <Col xs={{ span: 12 }} md={{ span: 8 }}>
                        <div className='viewsCount'>
                          <Icon icon='view' className='viewsIcon' />{" "}
                          <Text>
                            {data && data.count}
                            <span> Views</span>
                          </Text>
                        </div>
                      </Col>
                      <Col xs={{ span: 12 }} md={{ span: 12 }}>
                        <div className='productRating'>
                          <Text>{rate ? rate : "0.0"}</Text>
                          <Rate disabled defaultValue={rate ? rate : "0"} />

                          <span onClick={() => this.activeTab("3", "1")} className='reviews'>
                            {classifiedDetail.classified_hm_reviews && `(${classifiedDetail.classified_hm_reviews.length})`}
                          </span>
                        </div>
                      </Col>
                      <Col xs={{ span: 24 }}>
                        <div className='priceDetail'>
                          {data && (
                            <Title level={2} className='price'>
                              {"AU$"}
                              {salaryNumberFormate(parseInt(data.price))}
                            </Title>
                          )}
                        </div>
                      </Col>

                      {sizevisible && groupAtt && groupAtt.length !== 0 && classifiedDetail.is_inventory_added ? (
                        <Col xs={{ span: 24 }}>{this.renderInvAttSection()}</Col>
                      ) : (
                        <Col xs={{ span: 8 }} lg={{ span: 8 }}>
                          <div className='variationOptions'>
                            <label for='select-quantity'>Select Quantity</label>
                            <div className='chooseQuantity'>
                              <MinusOutlined onClick={() => this.handleNumberChange("decrement")} />
                              <Input type='number' value={selectedQuantity} onChange={(e) => this.handleNumberChange(e.target.value)} />
                              <PlusOutlined onClick={() => this.handleNumberChange("increment")} />
                            </div>
                          </div>
                        </Col>
                      )}

                      {sizevisible && groupAtt && groupAtt.length !== 0 && (
                        <Col xs={{ span: 24 }}>
                          <div className='viewSizeGiude'>
                            <div onClick={() => this.setState({ sizeGuideModel: true })}>
                              View Size Guide
                            </div>
                          </div>
                        </Col>
                      )}

                      <Col xs={{ span: 24 }}>
                        <div className={isPostageOpen ? "toggle-open deliveryAddCollapse" : "deliveryAddCollapse"} onClick={() => this.setState({ isPostageOpen: !isPostageOpen })}>
                          <div className='title'>
                            <h4>Postage, Delivery and Return </h4>
                            <DownOutlined />
                          </div>
                          {isPostageOpen && (
                            <div className='add-collapse-wrapper'>
                              <div className='details'>
                                <label>Postage:</label>
                                <div className='collapse-inner-data'>
                                  <p>
                                    <strong>{poatage_price ? poatage_price : "Free"}</strong> {postage_section && postage_section.ServiceType}{" "}
                                    <a href='Javasript:void(0)' onClick={() => this.activeTab("4", "1")}>
                                      See details
                                    </a>
                                  </p>
                                </div>
                              </div>
                              <div className='details'>
                                <label>Delivery:</label>
                                <div className='collapse-inner-data'>
                                  <p>
                                    Estimated between <strong>{`${postage_section.DeliveryDayOfWeek ? postage_section.DeliveryDayOfWeek : ""}  ${postage_section.DeliveryTimestamp ? moment(postage_section.DeliveryTimestamp).format("Do MMM") : ""}`}</strong>
                                  </p>
                                </div>
                              </div>
                              <div className='details'>
                                <label>Return:</label>
                                <div className='collapse-inner-data'>
                                  <p>
                                    {business_detail && business_detail.return_policy_title}
                                    <br />
                                    <a href='Javasript:void(0)' onClick={() => this.activeTab("4", "2")}>
                                      See details
                                    </a>
                                  </p>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </Col>
                      <Col xs={{ span: 24 }}>
                        <div className='addToCartBtn'>
                          <Button type='default' className='addToCart' onClick={this.addToCart}>
                            Add to Cart
                          </Button>
                          <div className='wishList' onClick={() => this.toggleWishlist(classified_id)} >
                            <Icon size='20'
                              icon={classifiedDetail?.is_favourite_count ? "wishlist-fill" : "wishlist"}
                              className={classifiedDetail?.is_favourite_count ? "active wishlistIcon" : "wishlistIcon"} />
                          </div>
                        </div>
                      </Col>
                      <Col xs={{ span: 24 }}>{this.renderPaymentMethods(business_detail, true)}</Col>
                      <Col xs={{ span: 24 }}>
                        <Row gutter={0} className='extraDetails'>
                          <Col xs={{ span: 14 }}>
                            {catName && (
                              <Link to={subCategoryPagePath} className='subCategoryName'>
                                <Button type='ghost' shape={"round"} className={"light-gray"}>
                                  {subCategoryName}
                                </Button>
                              </Link>
                            )}
                            <div className='adNum'>AD No. {product_id}</div>
                          </Col>
                          <Col xs={{ span: 10 }}>
                            <div className='reportAdv'>
                              {classifiedDetail.subcategoriesname && (
                                <label
                                  onClick={() => {
                                    if (classifiedDetail.is_reported === 1) {
                                      toastr.warning(langs.warning, MESSAGES.REPORT_ADD_WARNING);
                                    } else {
                                      if (isLoggedIn) {
                                        this.setState({
                                          reportAdModel: true,
                                        });
                                      } else {
                                        this.props.openLoginModel();
                                      }
                                    }
                                  }}
                                >
                                  <ExclamationCircleOutlined /> <u>Report this Ad</u>
                                </label>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>

              <Content>
                <div ref={this.myDivToFocus} className='productDetailTabWrap'>
                  <Tabs type='card' className={"productDetailTab"} activeKey={activeTab} onChange={this.onTabChange}>
                    <TabPane tab='Product Details' key='1'>
                      <div className='productDetails'>
                        <ProductDescription
                          allData={allData}
                          categoryName={categoryName}
                          classifiedDetail={classifiedDetail}
                          convertHTMLToText={convertHTMLToText}
                          inv_title1={inv_title1}
                          renderSpecification={this.renderSpecification}
                          selectedColorName={selectedColorName}
                          subCategoryName={subCategoryName}
                        />
                      </div>
                    </TabPane>
                    <TabPane tab='Product Reviews' key='3' ref={this.formRef}>
                      <div className='productReviews'>{classifiedDetail && <ProductReviews classifiedDetail={classifiedDetail} getDetails={() => this.getDetails(slug)} retail={true} />}</div>
                    </TabPane>
                    <TabPane tab='Postage And Payments' key='4'>
                      <div className='postagePaymentContainer'>
                        {classifiedDetail && business_detail && <PostageAndPayments
                          business_detail={business_detail}
                          classifiedDetail={classifiedDetail}
                          exclusion={exclusion}
                          getFedexResponsebyCountryCode={this.getFedexResponsebyCountryCode}
                          postage_delivery={postage_delivery}
                          postage_details={postage_details}
                          posting_to={posting_to}
                          postingCountryList={postingCountryList}
                          renderPaymentMethods={this.renderPaymentMethods}
                        />}
                      </div>
                    </TabPane>
                    <TabPane tab='Seller Information' key='5'>
                      <div className='sellerInfo'>{classifiedDetail && <SellerInformation classifiedDetail={classifiedDetail} getDetails={() => this.getDetails(slug)} cat_id={cat_id} />}</div>
                    </TabPane>
                  </Tabs>
                </div>
              </Content>
              {similarAd && similarAd.length ? (
                <div className='similarProductList'>
                  <h3>Browse Similar Listings</h3>
                  <div className='similarProductWrap'>
                    <Slider {...slickSettingsSimilarProduct}>
                      {similarAd.map((item, index) => {
                        return (
                          <div className='similarProductBlock' key={index}>
                            <div className='productImage'>

                              <Link to={getDetailPageRoute(langs.sellerType.retail, item.title, item.classifiedid)}>
                                <img src={item.imageurl ? item.imageurl : DefaultProductImage} alt='' />
                              </Link>
                            </div>
                            <div className='productContent'>
                              <Link to={getDetailPageRoute(langs.sellerType.retail, item.title, item.classifiedid)}>
                                <div className='title'>
                                  {item.title && item.title.substring(0, 40)}
                                  {item.title && item.title.length > 40 ? "..." : ""}
                                </div>
                                <div className='price'>{`AU$${item.price}`}</div>
                              </Link>
                            </div>
                          </div>
                        );
                      })}

                    </Slider>
                  </div>
                </div>
              ) : null}

              {sizeGuideModel && (
                <ViewSizeGuide
                  visible={sizeGuideModel}
                  onCancel={() => this.setState({ sizeGuideModel: false })}
                  size_guide_image={size_guide_image}
                />
              )}
            </div>
          </Layout>
        </>
      );
    } else {
      return <></>
    }
  }
}

const mapStateToProps = (store) => {
  const { auth: { loggedInUser, isLoggedIn },
    profile: { userProfile },
    common: { location }, itemDetails, classifieds } = store;
  return {
    itemDetails: itemDetails.itemDetails.data,
    loggedInUser, isLoggedIn,
    selectedclassifiedDetail: classifieds.classifiedsList,
    userDetails: userProfile ?? "",
    lat: location ? location.lat : "",
    long: location ? location.long : "",
  };
};

export default connect(mapStateToProps, {
  addToCartAction,
  checkFedexStatusAction,
  getItemDetailsAction,
  loadingAction,
  openLoginModel,
  toggleWishlistAction,
})(ProductDetails);
